import React from 'react';

const ErrorMessage = (props) =>{
 return <p className ='exceed-msg' >{`The amount accepted must be less than the Dispute Amount.`}</p>
}
export default ErrorMessage;
